const paywallMidpageStyle = Object.freeze({
  textColor: [ 'neutral', '-1', ],
  separatorColor: [ 'neutral', '-1', ],
  separatorLogoColor: [ 'primary', ],
  separatorIconSize: 5,
  fontStack: 'base',
  textType: 2,
  buttonType: 0,
  inputVariant: 'primaryOpaque',
  buttonVariant: 'primaryOpaque',
  closeArticleText: {
    fontWeight: 400,
    color: [ 'neutral', '-1', ],
    type: [
      { until: 'xl', value: 1, },
      { from: 'xl', value: 0, },
    ],
  },
});

export default paywallMidpageStyle;
